import { useMemo } from 'react';
import { SvgIconProps } from '@mui/material';
import SmileSadIcon from 'components/Icons/custom/SmileSadIcon';
import SmilePassiveIcon from 'components/Icons/custom/SmilePassiveIcon';
import SmileFunIcon from 'components/Icons/custom/SmileFunIcon';

interface EnergyLevelSmileIconProps {
  energyLevel: number | null | undefined;
  iconProps?: SvgIconProps;
}

export default function EnergyLevelSmileIcon({
  energyLevel,
  iconProps = {},
}: EnergyLevelSmileIconProps) {
  const smileIcon = useMemo(() => {
    if (!energyLevel || energyLevel < 1 || energyLevel > 10) {
      return null;
    }

    if (energyLevel >= 1 && energyLevel <= 5) {
      return <SmileSadIcon viewBox="0 0 17 17" color="error" {...iconProps} />;
    }
    if (energyLevel >= 6 && energyLevel <= 7) {
      return (
        <SmilePassiveIcon viewBox="0 0 17 17" color="warning" {...iconProps} />
      );
    }
    if (energyLevel >= 8 && energyLevel <= 10) {
      return (
        <SmileFunIcon viewBox="0 0 17 17" color="success" {...iconProps} />
      );
    }

    return null;
  }, [energyLevel, iconProps]);

  return smileIcon;
}
